import api from "./api";

export const getWhatsAppStatuses = async (params) => {
    const { data } = await api.get("/whatsapp-status", { params });
    return data;
};

export const getWhatsAppStatus = async (statusId) => {
    const { data } = await api.get(`/whatsapp-status/${statusId}`);
    return data;
};

export const createWhatsAppStatus = async (statusData) => {
    const { data } = await api.post("/whatsapp-status", statusData);
    return data;
};

export const sendWhatsAppStatus = async (statusId) => {
    const { data } = await api.post(`/whatsapp-status/${statusId}/send`);
    return data;
};

export const republishWhatsAppStatus = async (statusId) => {
    const { data } = await api.post(`/whatsapp-status/${statusId}/republish`);
    return data;
};

export const getContacts = async () => {
    const { data } = await api.get("/whatsapp-status/contacts");
    return data;
};

export const deleteWhatsAppStatus = async (statusId) => {
    const { data } = await api.delete(`/whatsapp-status/${statusId}`);
    return data;
};

export const uploadStatusMedia = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await api.post("/whatsapp-status/upload-media", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

    return data;
};
